// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { getUpDownMonthsAsAtDates } from '../../../../utils/disclaimers/comparison';
import { formatMessageWithLocale } from '../../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const UpDownMonthsDisclaimer = ({ items, showItemNames, locale }: Props) => (
  <DatesDisclaimer
    showItemNames={showItemNames}
    globalPrefix={formatMessageWithLocale('Disclaimers.UpDown', locale)}
    itemPrefix={formatMessageWithLocale('Disclaimers.EndingOn', locale)}
    itemDates={getUpDownMonthsAsAtDates(items, locale)}
    locale={locale}
  />
);

export default UpDownMonthsDisclaimer;
